// extracted by mini-css-extract-plugin
export default {"container":"InjuryRisk_container__04D0j","model":"InjuryRisk_model__jULsI","image":"InjuryRisk_image__2dWp6"};